<template>
	<div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
    	<div class="boxShadow setBorderRadius heig-frame-equipment-group">
      		<b-row no-gutters>
        		<b-col md="12" class="heig-frame-child">
        			<parts-replacement :show-import='true' name-table="part-replacement-history-asset-management-listing" @row-click="rowClick" ref="partsReplacement"></parts-replacement>
        		</b-col>
        	</b-row>
        </div>
    </div>
</template>
<script>
    const partsReplacement = () => import("./list.vue")
    import {mapGetters} from "vuex";
    export default {
        name: 'parts-replacement-history',
        components: {
        	partsReplacement
        },
        data() {
            return {
            }
        },
        created() {},
      	computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
      	},
        methods: {
            searchItem() {
                this.$refs.partsReplacement.$refs.gofixTable.tableRequest.filter.blk_address.value = null;
                this.$refs.partsReplacement.$refs.gofixTable.tableRequest.filter.search_part.value = null;
                this.$refs.partsReplacement.$refs.gofixTable.tableRequest.filter.search_lift_code.value = null;
                this.$refs.partsReplacement.$refs.gofixTable.tableRequest.filter.invoice_ref.value = null;
                this.$refs.partsReplacement.$refs.gofixTable.tableRequest.filter.dorj_number.value = null;
                this.$refs.partsReplacement.$refs.gofixTable.tableRequest.filter[this.search_by].value = this.search;
                this.$refs.partsReplacement.$refs.gofixTable.reloadTableKeepFilter();
            },
            rowClick(item) {
                let route = '';

                if(this.$checkSupplier()) {
                    route = this.$router.resolve(`/supplier-portal/parts-replacement/${item.row_id}`)
                }

                route = this.$router.resolve(`/v2/parts-replacement/${item.row_id}`)
                
                window.open(route.href, '_blank');
            },
        }
    }
</script>
